export default {
  chooseFile: "Choisissez un fichier",
  browse: "Parcourir",
  clearFile: "Supprimer le fichier",
  requiredField: "Ce champ est obligatoire",
  at_least_one_field_required: "Vous devez cochez au moins un choix dans cette ligne",
  requiredNumberOrFloat: "Merci de saisir un chiffre entier ou décimal",
  emailError: "Merci de saisir une adresse email conforme",
  phoneError: "Merci de saisir un numéro de téléphone conforme",
  lastName: "Nom",
  firstName: "Prénom",
  email: "Email",
  address: "Adresse",
  complement: "Complément",
  postCode: "Code postal",
  city: "Ville",
  phone: "Téléphone",
  mobile: "Mobile",
  function: "Fonction",
  actions: "Actions",
  rights: "Droits",
  send: "Envoyer",
  errors: "Attention, il y a des erreurs",
  form_validation: "Les champs suivants sont obligatoires :",
  entitled: "Intitulé",
  title: "Titre",
  selectValue: "Sélectionner une valeur",
  uploaded_on: "Mise en ligne le",
  error_file: "Oups, on dirait que le fichier est indisponible",
  no_skill_error_file: "Cet import de compétence est vide",
  download_success: "Fichier téléchargé avec succès !",
  file_downloading: "Téléchargement en cours...",
  download_file: "Télécharger le fichier",
  remove_file: "Retirer le fichier",
  signed_error: "Oups, il y'a eu une erreur lors de l'enregistrement",
  signed_success: "Les modifications ont bien été enregistrées",
  saving: "Enregistrement en cours",
  confirm: "Confirmer",
  import: "Importer",
  error_nofile: "Vous devez ajouter un fichier",
  error_file_format: "Veuillez ajouter un fichier au bon format !",
  error_date: "Veuillez renseigner une date de début antérieure à la date de fin",
  link: "Ouvrir le lien",
  dateChoice: "Cliquez pour choisir une date",
  next: "Suivant",
  pleaseWait: "Veuillez patienter ...",
  select: "Sélectionner",
  cancel: "Annuler",
  save: "Enregistrer",
  leave_without_save: "Quitter sans enregistrer",
  leave_confirmation: "Êtes-vous sûr de vouloir fermer sans sauvegarder ?",
  ok: "OK",
  edit: "Modifier",
  overview: "Aperçu",
  no: "Non",
  yes: "Oui",
  warning: "Attention",
  iConfirm: "Je confirme",
  Save: "Enregistrement",
  saveFinish: "L'enregistrement est terminé",
  fileFormatError: "Veuillez séléctionner un fichier au bon format",
  display: "Afficher",
  elements: "éléments",
  lines: "Lignes",
  conditions: {
    title: "Condition d'application du modèle",
    info: "Pour créer des modèles spécifiques, veuillez dupliquer le modèle par défaut et définir les conditions d'application (onglet 3)",
    alerte:
      "Par défaut, le modèle par défaut s'applique à tous les cas. Si vous définissez des conditions ci-dessous, le modèle ne s'appliquera que lorsque toutes les conditions sont remplies (logique ET).",
  },
  pagination: {
    to: "à",
    on: "sur",
  },
  close: "Fermer",
  submit: "Envoyer",
  back: "Retour",
  remove: "Enlever",
  regenerate: "Régénérer",
  typeYourSearch: "Tapez votre recherche...",
  sortBy: "Trier par",
  order: "Ordre",
  desc: "Décroissant",
  asc: "Croissant",
  reset: "Réinitialiser",
  filter: "Filtrer",
  Search: "Rechercher",
  "No data available in the table": "Aucune donnée disponible dans le tableau",
  "No data available": "Aucune donnée disponible",
  "Please enter or modify your search": "Veuillez saisir ou modifier votre recherche",
  "Please click on the add button": "Veuillez cliquer sur le bouton pour en ajouter",
  search: "Rechercher",
  All: "Tous",
  None: "Aucun",
  "PDF export": "Export PDF",
  "Excel export": "Export excel",
  "PNG export": "Export PNG",
  "SVG export": "Export SVG",
  "See statistics": "Voir les statistiques",
  multiselect: {
    press_enter: "",
    press_enter_group: "",
    selected: "",
    press_enter_remove: "",
    press_enter_remove_group: "",
    press_enter_create_tag: "Ajouter une valeur",
    select_option: "",
    no_result: "Aucun résultat ne correspond à votre recherche",
    no_options: "Tapez au moins {nb} caractères pour rechercher des résultats...",
  },
  init_search: "Réinitialiser la recherche",
  search_motor: "Moteur de recherche",
  file_size_error: "Le fichier choisi est trop volumineux, veuillez choisir un fichier de moins de ",
  maxTagError: "Veuillez respecter le nombre maximum de valeur",
  minTagError: "Veuillez respecter le nombre minimum de valeur",
  see_more_fields: "Voir plus de champs",
  justificative_piece: "Pièces justificatives",
  skillRecap: "Bilan de compétences",
  option_value: "Valeur",
  option_label: "Label",
  light: "Clair",
  dark: "Sombre",
  system: "Système",
  extensions_accepted:
    "Merci de sélectionner un fichier de type pdf, doc, xls, xlsx, csv, docx, jpeg, svg, bmp, gif ou png",
  valid: "Valider",
  unlock: "Déverouiller",
  tab_error: "Il y a une erreur sur cet onglet",
  regenerate_succes: "Identifiant régénéré avec succès !",
  password_validation: {
    title: "Veuillez saisir un mot de passe comprenant :",
    condition1: "Une lettre majuscule",
    condition2: "Une lettre minuscule",
    condition3: "Un chiffre",
    condition4: "Un caractère spécial",
    condition5: "Minimum 12 caractères",
  },
  dropzone: {
    release: "Relâcher les fichiers ici pour les ajouter.",
    drop: "Déposer les fichiers ici ou",
    click_here: "cliquer",
    to_upload: "pour en ajouter.",
    downloading: "Téléchargement en cours...",
    file: "Fichier",
    max_files: "Maximum {count} fichiers",
    max_files_message: "Vous avez atteint la limite de fichiers autorisée.",
    max_file_size: "La taille du fichier {name} dépasse la limite autorisée.",
    file_extension_error: "L'extension du fichier {name} n'est pas valide.",
    error_title: "Attention, certains fichiers n'ont pas été acceptés.",
    file_size_error: "La taille maximal par fichier est de {size} Mo.",
  },
  upload_signed_document: {
    label: "Déposer le document signé",
    one_file: "Vous devez insérer au minimum 1 fichier",
    file_only: "Merci de sélectionner un fichier pdf",
  },
  user_permissions: {
    archive_label: "Voir les promotions archivées",
    profile_label: "Voir tous les profils actifs",
    search_label: "Rechercher...",
    title: "Liste des profils de l'utilisateur",
    choose_profile: "Choisissez le profile à ajouter",
  },
  form_error: {
    verify_fields: "Certains champs du formulaire sont en erreur, veuillez les vérifier puis renvoyer le formulaire",
    minimum_value: "Valeur minimale : {value}",
    maximum_value: "Valeur maximale : {value}",
  },
};
